import script from "./GlossaryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GlossaryPage.vue?vue&type=script&setup=true&lang=js"

import "./GlossaryPage.vue?vue&type=style&index=0&id=66e61fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e61fee"]])

export default __exports__